import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Loader from 'src/components/loader/Loader';
import TransactionsTable from 'src/components/transactions-table/TransactionsTable';
import API from 'src/utils/api';
import rightArrowIcon from 'src/icons/right-arrow.svg';
import ErrorState from 'src/components/error-state/ErrorState';

const AllTransactions = () => {
    const fetchingTransactions = useRef(false);
    const [transactions, setTransactions] = useState();
    const [accounts, setAccounts] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (fetchingTransactions.current) return; // make sure to fetch data only at first render
        const fetchTransactions = async () => {
            fetchingTransactions.current = true;
            try {
                const response = await API.get('/accounts/transactions');
                setTransactions(response.data.transactions);
                setAccounts(response.data.accounts);
                setLoading(false);
                fetchingTransactions.current = false;
            } catch (error) {
                setError(true);
                setLoading(false);
                toast.error('Failed to fetch');
                fetchingTransactions.current = false;
            }
        };

        fetchTransactions();
    }, []);

    if (loading) {
        return (
            <div className="w-screen h-screen flex justify-center items-center">
                <Loader />
            </div>
        );
    }

    if (error) {
        return <ErrorState />;
    }

    return (
        <div className="px-10 pt-24 mb-10">
            <Link to="/" className="flex items-center mb-4">
                <img src={rightArrowIcon} alt="left arrow icon" className="rotate-180 mr-2" />
                Back
            </Link>
            <div className="lg:bg-gray-light lg:rounded-xl lg:px-6 lg:py-2">
                <TransactionsTable transactions={transactions} accounts={accounts} />
            </div>
        </div>
    );
};

export default AllTransactions;
